import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableCommissionsWalletService } from './table-commissions-wallet.service';
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { CommissionsService } from '../commissions/commissions.service';
import { ToastrService } from "ngx-toastr";
import { saveAs } from 'file-saver';
import { PdfService } from 'src/app/shared/services/pdf.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { CommissionsWalletService } from '../commissions-wallet/commissions-wallet.service';


@Component({
  selector: 'app-table-commissions-wallet',
  templateUrl: './table-commissions-wallet.component.html',
  styleUrls: ['./table-commissions-wallet.component.scss'],
  providers: [TableCommissionsWalletService, DecimalPipe, DatePipe]
})
export class TableCommissionsWalletComponent {

  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public transactionType: string = '';
  public selectedStatus: string = '';
  public selectedOrigin: string = '';
  public selectedApplciation: string = '';
  public personName: string = '';
  public searchType: string = '';
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;
  public receiptTemplate: string = '';
  public nameColumn: string = '';
  public account: any;
  public transactions: Array<any> = [];
  public startDateIso?: string;
  public endDateIso?: string;
  public pad(n: number) { return String(n).padStart(2, '0'); }
  langChangeSub!: Subscription;

  @Output() transactionsLoaded = new EventEmitter<any[]>();

  constructor(private commissionsWalletService: CommissionsWalletService,
    private tableCommissionsWalletService: TableCommissionsWalletService,
    private toastr: ToastrService,
    private pdfService: PdfService,
    private translate: TranslateService) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    this.selectedStatus = 'REALIZADO';
    this.getTransactions();
  }




  ngOnInit(): void {
    this.setTranslatedNameColumn();

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.setTranslatedNameColumn();
    })
  }

  setTranslatedNameColumn(): void {
    this.translate.get(['common.license', 'common.split']).subscribe(translations => {
      if (this.account?.nameColumn?.includes('LICENCIADO')) {
        this.nameColumn = translations['common.license'];
      } else {
        this.nameColumn = translations['common.split'];
      }
    });
  }

  isValidPixDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-02-05T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  isValidTefDate(transactionDate: string): boolean {
    const targetDate = new Date('2025-05-02T00:00:00Z');
    const transactionDateObj = new Date(transactionDate);

    return transactionDateObj.getTime() >= targetDate.getTime();
  }

  public getTransactions() {
    let dateInitialFormat: string;
    let dateFinalFormat: string;

    this.getAccount();

    if (this.startDateIso && this.endDateIso) {
      dateInitialFormat = this.startDateIso;
      dateFinalFormat = this.endDateIso;
    } else {
      const y1 = this.dataInitial.year, m1 = this.pad(this.dataInitial.month), d1 = this.pad(this.dataInitial.day);
      const y2 = this.dataFinal.year, m2 = this.pad(this.dataFinal.month), d2 = this.pad(this.dataFinal.day);
      dateInitialFormat = `${y1}-${m1}-${d1}T00:00:00`;
      dateFinalFormat = `${y2}-${m2}-${d2}T23:59:59`;
    }

    this.commissionsWalletService
      .getAccountSplits(dateInitialFormat, dateFinalFormat, this.page, this.pageSize, this.personName)
      .subscribe(value => {
        this.transactions = (value.splitResult ?? []) as any[];

        this.total = value.total ?? this.transactions.length;

        this.transactionsLoaded.emit(this.transactions);
      });
  }


  public getAccount() {
    this.tableCommissionsWalletService.getAccount().then(
      value => {
        this.account = value;
        if (this.account?.nameColumn) {
          if (this.account.nameColumn.includes('LICENCIADO')) {
            this.nameColumn = this.translate.instant('common.license');
          } else {
            this.nameColumn = this.translate.instant('common.split');
          }
        }
      }
    ).catch(error => {
      console.error('Error fetching account:', error);
    });
  }

  pageChange() {
    this.getTransactions();
  }

  async downloadReceipt(transaction: any) {
    this.toastr.success('Seu comprovante está sendo gerado', 'Sucesso', {
      timeOut: 3000,
      positionClass: 'toast-top-right',
    });

    const response = await firstValueFrom(this.pdfService.reportWithdraw(transaction));

    const byteCharacters = atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);


    const blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, 'comprovante.pdf');
  }
}



